module.exports = "https://static.wmbcdn.com/uniweb/images/6d3d2afaeaa96109b4a88bb0eb58bb08.svg";